import { create } from "zustand";
import { devtools } from "zustand/middleware";

import { GetAllProgramResponse } from "@/accountability/modules/programs/services";

import { findProgramIdByCategoryAndDescription } from "./helpers/findProgramIdByCategoryAndDescription";

type ProgramStoreT = {
  programs: GetAllProgramResponse;
  setPrograms: (newProgram: GetAllProgramResponse) => void;
  getProgramId: (categoryDescription: string, programDescription: string) => number;
};

export const useProgramStore = create<ProgramStoreT>()(
  devtools((set, get) => ({
    programs: [],
    setPrograms: (newProgram: GetAllProgramResponse) => {
      set(() => ({ programs: newProgram }));
    },

    getProgramId: (categoryDescription: string, programDescription: string): number => {
      let programId;

      const programFound = get().programs.find((program) =>
        findProgramIdByCategoryAndDescription(program, programDescription, categoryDescription),
      );
      if (programFound) {
        programId = programFound.categories.find(
          (category) => category.category === categoryDescription,
        )?.programId;
      }
      return programId || -1;
    },
  })),
);
